import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../components/SideBar';
import NavBar from '../../components/NavBarSearchSong';
import Settings from '../../assets/Settings.png';
import search from '../../assets/ic_search.png';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@material-ui/core';
import './SearchSongs.scss';
import { _showAlert, formatDateToDisplay } from '../../utils';
import RoundButton from '../../components/RoundButton';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Autocomplete, TextField } from '@mui/material';
import InfoIcon from "../../components/Svgs/InfoIcon.svg"
import SearchInfoPlaylistPopup from '../../components/SearchInfoPlaylistPopup/SearchInfoPlaylistPopup';
import SortIndicator from '../../components/SortIndicator';
import PlayBtn from '../../assets/play_btn.svg';
import DeleteIcon from '../../assets/Delete.png';
import { addSongToPlaylist } from '../../api/playlist';
import WarningIcon from '../../components/Svgs/WarningIcon.svg.js';
import { colorIsDarkSimple } from '../../generalConstant';
import useRangeSelection, { updateSelectedItems } from '../../utils/useRangeSelection';
import RangeSelectionButton from '../../components/RangeSelectionButton';

/**
 * material ui table style object
 */
const useStyles = makeStyles({
  table: {
    minWidth: 700,
    borderRadius: 30,
  },
});

function SearchSong() {
  const songsList = useSelector((state) => state.searchSongs.result);
  const deleteSongs = useSelector((state) => state.deleteSongs);
  const { result: getAllPlaylist, status: playlistStatus } = useSelector((state) => state.getAllPlaylist);
  const { result: tagList, status: tagStatus } = useSelector((state) => state.tagList);

  const dispatch = useDispatch();
  const classes = useStyles();
  const [searchInput, setSearchInput] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedSongs, setSelectedSongs] = useState([]);
  const { choose: chooseRange, toggleRangeMode, resetRange, isRangeMode } = useRangeSelection();
  const [pendingDeleteSongs, setPendingDeleteSongs] = useState([]);
  const [deleteInitiated, setDeleteInitiated] = useState(false);
  const [date, setDate] = useState(null);
  const [selectedSongPlaylists, setSelectedSongPlaylists] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [navbarCurrentSong, setNavbarCurrentSong] = useState(null);
  const [playlistPickerSong, setPlaylistPickerSong] = useState(null);
  const [playlistSearch, setPlaylistSearch] = useState('');
  const [playlistTypeFilter, setPlaylistTypeFilter] = useState('all');
  const [selectedPlaylistTags, setSelectedPlaylistTags] = useState([]);
  const [addingPlaylistId, setAddingPlaylistId] = useState(null);
  const [addedPlaylistIds, setAddedPlaylistIds] = useState([]);

  const authData = JSON.parse(sessionStorage.getItem('authData') || '{}');
  const isAdmin = authData?.user?.userRole === 1;

  // Sorting state
  const [sortConfig, setSortConfig] = useState({ key: 'createdAt', direction: 'desc' });

  const handleChange = (newValue) => {
    setDate(newValue);
  };

  /**
   * Close Modal
   */
  const handleClose = () => setOpen(false);

  const handleSelectAll = () => {
    if (!Array.isArray(songsList)) return;
    const allSelected = songsList.length > 0 && songsList.every(song => selectedSongs.some(selected => selected.id === song.id));
    setSelectedSongs(allSelected ? [] : songsList);
    resetRange('search-songs');
  };

  const handleSongSelection = (song, event) => {
    const selection = chooseRange('search-songs', visibleSongs, song, event.target.checked, !!event.nativeEvent?.shiftKey);
    setSelectedSongs((current) => updateSelectedItems(current, selection));
  };

  const handleDeleteSelected = (songs = selectedSongs) => {
    if (songs.length > 0) {
      setPendingDeleteSongs(songs);
      setOpen(true);
    }
  };

  const handleDeleteSong = () => {
    setOpen(false);
    const songIds = pendingDeleteSongs.map(song => song.id);
    dispatch({ type: 'DELETE_SONGS_RESET' });
    setDeleteInitiated(true);
    dispatch({ type: 'DELETE_SONGS', payload: { ids: songIds } });
  };

  const openPlaylistPicker = (song) => {
    setPlaylistPickerSong(song);
    setPlaylistSearch('');
    setPlaylistTypeFilter('all');
    setSelectedPlaylistTags([]);
    setAddedPlaylistIds([]);
    dispatch({ type: 'GET_ALL_PLAYLIST', payload: '' });
    dispatch({ type: 'TAG_LIST' });
  };

  const handleAddToPlaylist = async (playlist) => {
    if (!playlistPickerSong || addingPlaylistId) return;
    setAddingPlaylistId(playlist.id);
    try {
      const result = await addSongToPlaylist(playlist.id, playlistPickerSong.id);
      setAddedPlaylistIds((current) => [...current, playlist.id]);
      dispatch({ type: 'GET_ALL_PLAYLIST', payload: '' });
      _showAlert(result.alreadyAdded ? 'Song is already in this playlist' : 'Song added to playlist', 'success');
    } catch (error) {
      _showAlert('Could not add the song to this playlist', 'error');
    } finally {
      setAddingPlaylistId(null);
    }
  };

  const handleDetails = (row) => {
    const playlistsWithSong = Array.isArray(getAllPlaylist)
      ? getAllPlaylist.filter(playlist =>
        playlist.songs.some(song => song.id === row.id)
      )
      : [];
    setSelectedSongPlaylists(playlistsWithSong);
  }

  const handleSort = (key) => {
    let direction = 'desc';
    let newKey = key;

    if (sortConfig.key === key) {
      if (sortConfig.direction === 'desc') {
        direction = 'asc';
      } else {
        newKey = null;
      }
    }

    setSortConfig({ key: newKey, direction });
  };

  const sortSongs = (songs) => {
    if (!sortConfig.key || !Array.isArray(songs)) return songs;

    return [...songs].sort((a, b) => {
      if (sortConfig.key === 'createdAt') {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return sortConfig.direction === 'asc' ? dateA - dateB : dateB - dateA;
      }

      if (sortConfig.key === 'title') {
        const titleA = a.title || '';
        const titleB = b.title || '';
        return sortConfig.direction === 'asc' ? titleA.localeCompare(titleB) : titleB.localeCompare(titleA);
      }

      if (sortConfig.key === 'artist') {
        const artistA = a.artist || '';
        const artistB = b.artist || '';
        return sortConfig.direction === 'asc' ? artistA.localeCompare(artistB) : artistB.localeCompare(artistA);
      }

      return 0;
    });
  };

  const visibleSongs = sortSongs(Array.isArray(songsList) ? songsList : []);
  const currentSongIndex = navbarCurrentSong ? visibleSongs.findIndex(song => song.id === navbarCurrentSong.id) : -1;
  const playSong = (song) => setNavbarCurrentSong({ ...song, name: song.title });
  const editablePlaylists = Array.isArray(getAllPlaylist)
    ? getAllPlaylist.filter(playlist =>
      (playlist.type === 3 || playlist.type === 4) &&
      (playlistTypeFilter === 'all' || playlist.type === (playlistTypeFilter === 'royalty' ? 3 : 4)) &&
      (selectedPlaylistTags.length === 0 || playlist.tags?.some(tag =>
        selectedPlaylistTags.some(selectedTag => selectedTag.id === (tag.tagId || tag.id)))) &&
      playlist.name?.toLowerCase().includes(playlistSearch.toLowerCase()))
    : [];
  const playlistCount = Array.isArray(getAllPlaylist)
    ? getAllPlaylist.filter(playlist => playlist.type === 3 || playlist.type === 4).length
    : 0;

  useEffect(() => {
    if (!deleteInitiated) return;
    if (deleteSongs.status === 'success') {
      const deletedIds = pendingDeleteSongs.map(song => song.id);
      setSelectedSongs([]);
      setNavbarCurrentSong(current => current && deletedIds.includes(current.id) ? null : current);
      dispatch({ type: 'SEARCH_SONGS', payload: { search: searchInput.trim(), date: date ? date.format('DD-MM-YYYY') : null } });
      dispatch({ type: 'GET_ALL_PLAYLIST', payload: '' });
      _showAlert(`${deletedIds.length} song${deletedIds.length === 1 ? '' : 's'} permanently deleted`, 'success');
      setPendingDeleteSongs([]);
      setDeleteInitiated(false);
      dispatch({ type: 'DELETE_SONGS_RESET' });
    } else if (deleteSongs.status === 'failed') {
      _showAlert('Could not delete the selected songs', 'error');
      setDeleteInitiated(false);
      dispatch({ type: 'DELETE_SONGS_RESET' });
    }
  }, [deleteSongs.status, deleteInitiated, pendingDeleteSongs, searchInput, date, dispatch]);

  /**
   * It will handle Serach Songs
   * watch the changes of the searchInput component state
   */
  useEffect(() => {
    const formattedDate = date ? date.format('DD-MM-YYYY') : null;
    setSelectedSongs([]);
    resetRange('search-songs');
    dispatch({
      type: 'SEARCH_SONGS',
      payload: {
        search: searchInput.trim() || "",
        date: formattedDate || null
      }
    });
  }, [searchInput, date, dispatch, resetRange]);

  useEffect(() => {
    dispatch({ type: 'GET_ALL_PLAYLIST', payload: '' });
  }, [dispatch]);

  /**
   * get called on component unmount
   * clear the delete song redux state
   */
  useEffect(() => {
    dispatch({ type: 'DELETE_SONGS_RESET' });
    return () => {
      dispatch({ type: 'DELETE_SONGS_RESET' });
    };
  }, [dispatch]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <Dialog className="search-song-dialog song-delete-dialog" open={open} onClose={handleClose} fullWidth maxWidth="xs" aria-labelledby="song-delete-title">
          <DialogTitle id="song-delete-title">
            <span className="song-delete-icon"><WarningIcon width={36} height={36} /></span>
            Permanently delete {pendingDeleteSongs.length === 1 ? 'song' : `${pendingDeleteSongs.length} songs`}?
          </DialogTitle>
          <DialogContent>
            <p className="search-song-dialog-description">
              {pendingDeleteSongs.length === 1 && <strong>{pendingDeleteSongs[0]?.title}</strong>}
              {pendingDeleteSongs.length === 1 ? ' will be' : 'These songs will be'} removed from the server and every playlist containing {pendingDeleteSongs.length === 1 ? 'it' : 'them'}.
              {' '}This action cannot be undone.
            </p>
            {pendingDeleteSongs.length > 1 && <div className="song-delete-selection">
              {pendingDeleteSongs.slice(0, 5).map(song => <div key={song.id}>{song.title}</div>)}
              {pendingDeleteSongs.length > 5 && <div>and {pendingDeleteSongs.length - 5} more</div>}
            </div>}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button className="song-delete-confirm" variant="contained" onClick={handleDeleteSong}>Permanently delete</Button>
          </DialogActions>
        </Dialog>
        <div className="leftPortion">
          <NavBar
            data="Search song"
            icon={Settings}
            currentRouteName="Songs"
            breadcrumbsPath="Search Songs"
            showPlayer={true}
            currentSong={navbarCurrentSong}
            onNextSong={() => playSong(visibleSongs[currentSongIndex + 1])}
            hasNextSong={currentSongIndex >= 0 && currentSongIndex < visibleSongs.length - 1}
            onPrevSong={() => playSong(visibleSongs[currentSongIndex - 1])}
            hasPrevSong={currentSongIndex > 0}
            onClosePlayer={() => setNavbarCurrentSong(null)}
          />
          <div className="content">
            <div className="filter_row">
              <div className="search_row">
                <input
                  className="input_field"
                  placeholder="search songs Here..."
                  type="text"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <img src={search} alt="search" />
              </div>
              <div className="date-picker-container">
                <DesktopDatePicker
                  inputFormat="MM/DD/YYYY"
                  value={date}
                  disableFuture
                  disableHighlightToday
                  onChange={handleChange}
                  renderInput={(params) => <TextField {...params}
                    variant="outlined"
                    placeholder="Select Date"
                    className="date-picker"
                  />}
                />
              </div>
              {isAdmin && <div className="button-container">
                <RoundButton
                  btnText={deleteInitiated ? 'Deleting...' : 'Delete Selected'}
                  handleClick={() => handleDeleteSelected()}
                  disabled={selectedSongs.length === 0 || deleteInitiated}
                  className={selectedSongs.length === 0 || deleteInitiated ? 'disabled' : ''}
                />
              </div>}
            </div>
            <TableContainer className="tbl_wraper" component={Paper}>
              <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell>{/* <Checkbox inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} /> */}</TableCell>
                    <TableCell className="table_font">Result</TableCell>
                    <TableCell
                      onClick={() => handleSort('createdAt')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Date<SortIndicator sortConfig={sortConfig} columnKey="createdAt" />
                    </TableCell>
                    <TableCell
                      onClick={() => handleSort('title')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Song Name<SortIndicator sortConfig={sortConfig} columnKey="title" />
                    </TableCell>
                    <TableCell
                      onClick={() => handleSort('artist')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Artist<SortIndicator sortConfig={sortConfig} columnKey="artist" />
                    </TableCell>
                    <TableCell>Processing Status</TableCell>
                    <TableCell>Actions</TableCell>
                    <TableCell>Details</TableCell>
                    {isAdmin && <TableCell>
                      <Checkbox
                        checked={Array.isArray(songsList) && songsList.length > 0 && songsList.every(song => selectedSongs.some(selected => selected.id === song.id))}
                        onChange={handleSelectAll}
                        inputProps={{ 'aria-label': 'Select all search results' }}
                      />
                      <RangeSelectionButton active={isRangeMode('search-songs')} onClick={() => toggleRangeMode('search-songs')} />
                    </TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(songsList) &&
                    visibleSongs.map((row, index) => (
                      <TableRow key={row.id}>
                        <TableCell>{/* <Checkbox inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} /> */}</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }}>#{++index}</TableCell>
                        <TableCell>{formatDateToDisplay(row.createdAt)}</TableCell>
                        <TableCell>{row.title}</TableCell>
                        <TableCell>{row.artist || 'N/A'}</TableCell>
                        <TableCell>
                          {row.processingStatus
                            ? row.processingStatus.status?.charAt(0)?.toUpperCase() + row.processingStatus.status?.slice(1)
                            : '-'}
                        </TableCell>
                        <TableCell>
                          <div className="song-actions">
                            <Tooltip title="Listen to song" arrow>
                              <button type="button" aria-label={`Listen to ${row.title || 'song'}`} onClick={() => playSong(row)}>
                                <img src={PlayBtn} alt="" />
                              </button>
                            </Tooltip>
                            <Tooltip title="Add to playlist" arrow>
                              <button type="button" aria-label={`Add ${row.title || 'song'} to playlist`} onClick={() => openPlaylistPicker(row)}>
                                <svg viewBox="0 0 20 20" width="21" height="21" fill="none" stroke="currentColor" strokeLinecap="round" aria-hidden="true">
                                  <circle cx="10" cy="10" r="9" strokeWidth="2" />
                                  <path d="M10 5.5v9M5.5 10h9" strokeWidth="2.5" />
                                </svg>
                              </button>
                            </Tooltip>
                            {isAdmin && <Tooltip title="Permanently delete song" arrow>
                              <span>
                                <button type="button" aria-label={`Permanently delete ${row.title || 'song'}`} disabled={deleteInitiated} onClick={() => handleDeleteSelected([row])}>
                                  <img src={DeleteIcon} alt="" />
                                </button>
                              </span>
                            </Tooltip>}
                          </div>
                        </TableCell>
                        <TableCell style={{ paddingLeft: '25px' }}>
                          <Tooltip title="View playlists containing this song" arrow>
                            <button type="button" className="song-details-action" aria-label={`View playlists containing ${row.title || 'song'}`} onClick={() => {
                              handleDetails(row);
                              setIsPopupOpen(true);
                            }}>
                              <InfoIcon color="#000000" width={32} height={32} />
                            </button>
                          </Tooltip>
                        </TableCell>
                        {isAdmin && <TableCell>
                          <Checkbox
                            checked={selectedSongs.some(selected => selected.id === row.id)}
                            onChange={(event) => handleSongSelection(row, event)}
                            inputProps={{ 'aria-label': `Select ${row.title || 'song'}` }}
                          />
                        </TableCell>}
                      </TableRow>
                    ))}
                  {Array.isArray(songsList) && songsList.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={isAdmin ? 9 : 8} style={{ textAlign: 'center' }}>No songs found</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        <SearchInfoPlaylistPopup open={isPopupOpen} onClose={() => setIsPopupOpen(false)} playlists={selectedSongPlaylists} />
        <Dialog className="search-song-dialog playlist-picker-dialog" open={!!playlistPickerSong} onClose={() => !addingPlaylistId && setPlaylistPickerSong(null)} maxWidth={false} aria-labelledby="playlist-picker-title">
          <DialogTitle id="playlist-picker-title">Add to playlist</DialogTitle>
          <DialogContent>
            <p className="search-song-dialog-description">Choose one or more playlists for <strong>{playlistPickerSong?.title}</strong>. Playlists that already contain this song are marked Added.</p>
            <div className="playlist-picker-controls">
              <input
                className="playlist-picker-search"
                type="search"
                placeholder="Search playlists"
                value={playlistSearch}
                onChange={(event) => setPlaylistSearch(event.target.value)}
                aria-label="Search playlists"
              />
              <Autocomplete
                multiple
                size="small"
                limitTags={2}
                options={tagList?.tags || []}
                value={selectedPlaylistTags}
                getOptionLabel={(option) => option?.name || ''}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                filterSelectedOptions
                onChange={(event, tags) => setSelectedPlaylistTags(tags)}
                loading={tagStatus === 'initiated'}
                renderInput={(params) => <TextField {...params} placeholder="Filter by tags" aria-label="Filter playlists by tags" />}
              />
            </div>
            {tagStatus === 'failed' && <div className="playlist-picker-tag-error">
              Could not load tags. <Button size="small" color="primary" onClick={() => dispatch({ type: 'TAG_LIST' })}>Try again</Button>
            </div>}
            <div className="playlist-picker-filters" role="group" aria-label="Filter playlists by type">
              {[
                { value: 'all', label: 'All' },
                { value: 'royalty', label: 'Royalty' },
                { value: 'non-royalty', label: 'Non-Royalty' },
              ].map(filter => (
                <button
                  key={filter.value}
                  type="button"
                  className={playlistTypeFilter === filter.value ? 'active' : ''}
                  aria-pressed={playlistTypeFilter === filter.value}
                  onClick={() => setPlaylistTypeFilter(filter.value)}
                >
                  {filter.label}
                </button>
              ))}
            </div>
            <div className="playlist-picker-summary">
              {playlistStatus === 'success' && `Showing ${editablePlaylists.length} of ${playlistCount} playlist${playlistCount === 1 ? '' : 's'}`}
            </div>
            {playlistStatus === 'initiated' || playlistStatus === 'uninitiated' ? (
              <div className="playlist-picker-state"><CircularProgress size={24} /><span>Loading playlists...</span></div>
            ) : playlistStatus === 'failed' ? (
              <div className="playlist-picker-state">
                <p>Could not load playlists.</p>
                <Button color="primary" onClick={() => dispatch({ type: 'GET_ALL_PLAYLIST', payload: '' })}>Try again</Button>
              </div>
            ) : <TableContainer className="playlist-picker-table" component={Paper}>
              <Table stickyHeader size="small" aria-label="Playlists available for this song">
                <TableHead><TableRow>
                  <TableCell>Playlist</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Tags</TableCell>
                  <TableCell align="center">Songs</TableCell>
                  <TableCell align="right">Action</TableCell>
                </TableRow></TableHead>
                <TableBody>
                  {editablePlaylists.map((playlist) => {
                    const alreadyAdded = addedPlaylistIds.includes(playlist.id) || playlist.songs?.some(song => song.id === playlistPickerSong?.id);
                    return <TableRow key={playlist.id}>
                      <TableCell><span className="playlist-picker-name"><span className="playlist-picker-avatar" aria-hidden="true">{playlist.name?.charAt(0)?.toUpperCase() || 'P'}</span><strong>{playlist.name}</strong></span></TableCell>
                      <TableCell>{playlist.type === 3 ? 'Royalty' : 'Non-Royalty'}</TableCell>
                      <TableCell><span className="playlist-picker-tags">
                        {playlist.tags?.length ? playlist.tags.map(tag => <span key={tag.tagId || tag.id} title={tag.name} style={{ backgroundColor: tag.color || '#e7ddff', color: tag.color && colorIsDarkSimple(tag.color) ? '#fff' : '#111' }}>{tag.name}</span>) : '—'}
                      </span></TableCell>
                      <TableCell align="center">{playlist.songs?.length || 0}</TableCell>
                      <TableCell align="right">
                        {alreadyAdded ? <span className="playlist-picker-added">✓ Added</span> :
                          <Button
                            color="primary"
                            variant="contained"
                            disabled={!!addingPlaylistId}
                            onClick={() => handleAddToPlaylist(playlist)}
                            aria-label={`Add song to ${playlist.name}`}
                          >
                            {addingPlaylistId === playlist.id ? <CircularProgress size={20} color="inherit" /> : 'Add'}
                          </Button>}
                      </TableCell>
                    </TableRow>;
                  })}
                  {editablePlaylists.length === 0 && <TableRow><TableCell colSpan={5} align="center">{playlistCount === 0 ? 'No editable playlists are available.' : 'No playlists match your filters.'}</TableCell></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>}
          </DialogContent>
          <DialogActions><Button onClick={() => setPlaylistPickerSong(null)} disabled={!!addingPlaylistId}>Done</Button></DialogActions>
        </Dialog>
      </div>
    </LocalizationProvider>
  );
}
export default SearchSong;
